import { DatePipe, NgFor, NgIf } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { Router } from "@angular/router";
import { TranslocoPipe } from "@ngneat/transloco";
import { AcBadgeComponent } from "app/shared/components/ac-badge/ac-badge.component";
import { AcButtonComponent } from "app/shared/components/ac-button/ac-button.component";
import {
    categoryIcon as sharedCategoryIcon,
    categoryLabel as sharedCategoryLabel,
} from "../utils/changelog-categories";
import {
    ChangelogModalAction,
    ChangelogTelemetryService,
} from "../services/changelog-telemetry.service";
import { ChangelogRelease, ChangelogSection } from "../models/changelog.types";

interface SectionHighlight {
    category: ChangelogSection["category"];
    count: number;
}

@Component({
    selector: "app-changelog-news-modal",
    standalone: true,
    templateUrl: "./changelog-news-modal.component.html",
    imports: [
        NgFor,
        NgIf,
        DatePipe,
        MatDialogModule,
        MatIconModule,
        TranslocoPipe,
        AcBadgeComponent,
        AcButtonComponent,
    ],
})
export class ChangelogNewsModalComponent {
    release: ChangelogRelease;
    highlights: SectionHighlight[];

    constructor(
        private _dialogRef: MatDialogRef<ChangelogNewsModalComponent>,
        private _router: Router,
        private _telemetry: ChangelogTelemetryService,
        @Inject(MAT_DIALOG_DATA) data: { release: ChangelogRelease }
    ) {
        this.release = data.release;
        this.highlights = (this.release.sections ?? [])
            .filter((s) => (s.entries?.length ?? 0) > 0)
            .map((s) => ({ category: s.category, count: s.entries.length }));

        this._telemetry.trackModalShown({ releaseId: this.release.id });
    }

    readonly categoryLabel = sharedCategoryLabel;
    readonly categoryIcon = sharedCategoryIcon;

    openChangelog(): void {
        this._dismissWith("cta");
        this._router.navigate(["/changelog"]);
    }

    skip(): void {
        this._dismissWith("skip");
    }

    close(): void {
        this._dismissWith("close");
    }

    trackByHighlight(_index: number, item: SectionHighlight): string {
        return item.category;
    }

    private _dismissWith(action: ChangelogModalAction): void {
        this._telemetry.trackModalDismissed({ releaseId: this.release.id, action });
        this._dialogRef.close();
    }
}
